export default __webpack_public_path__ + "static/media/6.b2816908.jpg";